import * as constants from './constants';

export const showSearchFilters = () => ({
  type: constants.SHOW_SEARCH_FILTERS,
});

export const hideSearchFilters = () => ({
  type: constants.HIDE_SEARCH_FILTERS,
});

export const activateUserFilterInteraction = () => ({
  type: constants.ACTIVATE_USER_FILTER_INTERACTION,
});



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/actions.js